import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import CloudSyncIcon from "@mui/icons-material/CloudSync";
import RestoreIcon from "@mui/icons-material/Restore";
import SensorsOffIcon from "@mui/icons-material/SensorsOff";
import { Button, Paper, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import clsx from "clsx";
import React from "react";
import { useStyles } from "./HelpStyle";

export interface IDisplayOfOptionComponent {
  displayNextSlide: () => void;
}

const DisplayOfOptionComponent = (props: IDisplayOfOptionComponent) => {
  const classes = useStyles();
  const [selectedOption, setSelectedOption] = React.useState([
    false,
    false,
    false,
  ]);
  const [isDisable, setBtnDisable] = React.useState(true);
  const [isError, setError] = React.useState(false);

  React.useEffect(() => {
    if (selectedOption[1]) {
      setError(true);
    } else setError(false);

    if (selectedOption[0] && selectedOption[1] && selectedOption[2]) {
      setBtnDisable(true);
    } else if (selectedOption[0] && selectedOption[2]) {
      setBtnDisable(false);
    } else setBtnDisable(true);
  }, [selectedOption]);
  const updateSelectedOption = (key: number) => {
    setSelectedOption([
      key === 0 ? !selectedOption[0] : selectedOption[0],
      key === 1 ? !selectedOption[1] : selectedOption[1],
      key === 2 ? !selectedOption[2] : selectedOption[2],
    ]);
  };

  const levelOptionsList = [
    {
      level: "1",
      list: ["Disconnect from outside network"],
      icon: <SensorsOffIcon />,
    },
    {
      level: "2",
      list: ["Allow network to be as usual"],
      icon: <CloudSyncIcon />,
    },
    {
      level: "3",
      list: ["Restore recent backups quickly"],
      icon: <RestoreIcon />,
    },
  ];

  const handleClick = () => {
    props.displayNextSlide();
  };
  return (
    <Box className={clsx(classes.positionComponent, classes.bgDiv)}>
      <Paper className={classes.optionDiv}>
        <Typography variant="h5" sx={{ fontWeight: "600" }}>
          Next steps
        </Typography>
        <Typography
          variant="body2"
          sx={isError ? { marginBottom: "0.5rem" } : { marginBottom: "2rem" }}
        >
          You can select multiple options
        </Typography>
        {isError && (
          <div className={classes.errorDiv}>
            <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
              Leaving the hospital with compromised networks exposed to the
              Internet can cause more damage. The hospital
            </Typography>
            <Typography variant="caption" sx={{ fontSize: "0.7rem" }}>
              network needs to be isolated which gives IT teams time to isolate
              and remove malicious code
            </Typography>
          </div>
        )}
        <div style={{ margin: "0.5rem 0" }}>
          {levelOptionsList.map((element, index) => {
            return (
              <Paper
                onClick={() => updateSelectedOption(index)}
                className={classes.options}
                key={index}
                sx={
                  selectedOption[index]
                    ? { border: "0.125rem solid #FFFFFF" }
                    : { border: "0.125rem solid #56CCF2" }
                }
              >
                <div className={classes.circle}>
                  {selectedOption[index] ? (
                    <CheckCircleOutlinedIcon
                      className={classes.checkboxCircle}
                      sx={{ backgroundColor: "#56CCF2", color: "white" }}
                    />
                  ) : (
                    <CircleOutlinedIcon
                      className={classes.checkboxCircle}
                      sx={{ backgroundColor: "#5B8297", color: "#56CCF2" }}
                    />
                  )}
                  <Typography className={classes.circleText}>
                    {element.level}
                  </Typography>
                </div>
                <div className={classes.levelDiv}>
                  {element.icon}
                  <Typography className={classes.levelText}>
                    {element.list}
                  </Typography>
                </div>
              </Paper>
            );
          })}
        </div>
        <Button
          sx={{
            borderRadius: "3rem",
            textTransform: "capitalize",
            padding: "0.5rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "600",
          }}
          variant="contained"
          endIcon={<ArrowForwardIcon />}
          onClick={handleClick}
          disabled={isDisable}
        >
          Continue
        </Button>
      </Paper>
    </Box>
  );
};

export default DisplayOfOptionComponent;
